import { render, staticRenderFns } from "./iframe-dialog.vue?vue&type=template&id=0fa18dfb&scoped=true&"
import script from "./iframe-dialog.vue?vue&type=script&lang=js&"
export * from "./iframe-dialog.vue?vue&type=script&lang=js&"
import style0 from "./iframe-dialog.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./iframe-dialog.vue?vue&type=style&index=1&id=0fa18dfb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa18dfb",
  null
  
)

export default component.exports